import { LinkService } from './../../../predictor/services/link.service';
import { Component, Inject, OnInit } from '@angular/core';
import {
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError,
  Router,
} from '@angular/router';
import { MenuItem } from 'primeng/api';
import { Observable, BehaviorSubject, filter, map, take } from 'rxjs';
import { MsalService } from '@azure/msal-angular';
import { APP_CONFIG, AppConfig } from 'src/app/appconfig/appconfig';
import { UserState } from '../../../state/user/user.state';
import { NavmenuItem } from '@stantec/basin/nav-menu';
import { Select, Store } from '@ngxs/store';
import { UserProfileRead } from '../../../user/interfaces/user-profile-read';
import { UserActions } from 'src/app/state/user/user.actions';
import { LoggedInUserLicenseDetails } from 'src/app/predictor-enterprise-license/shared/interface/Enterprise-License';
import { NotificationsActions } from 'src/app/state/notifications/notifications.actions';
import { Severity } from '../../enums/severity';
import {MessageService} from 'primeng/api';
import { ExpiryNotificationService } from '../expiry-notification/expiry-notification-service';
import { AppDatePipe } from 'src/app/predictor-enterprise-license/shared/pipes/app-date-pipe';
import { APP_DATE_FORMATS } from 'src/app/predictor-enterprise-license/shared/interface/date-formats.constants';


@Component({
  selector: 'app-primary-navigation',
  templateUrl: './primary-navigation.component.html',
  styleUrls: ['./primary-navigation.component.scss'],
})
export class PrimaryNavigationComponent implements OnInit {
  @Select(UserState.userImage) userImage$!: Observable<string>;
  @Select(UserState.userProfile) userProfile$!: Observable<UserProfileRead>;

  loading$: Observable<boolean> = new BehaviorSubject<boolean>(false);

  homeLink: string = this.appConfig.digitalAccessPortal.url;
  private LicenseUser: LoggedInUserLicenseDetails | null = null;
  private hasShownRenewalPendingToast = false;

  loadingIndicator() {
    this.loading$ = this.router.events.pipe(
      filter(
        (e) =>
          e instanceof NavigationStart ||
          e instanceof NavigationEnd ||
          e instanceof NavigationCancel ||
          e instanceof NavigationError
      ),
      map((e) => e instanceof NavigationStart)
    );
  }

  navItems: NavmenuItem[] = [
    {
      header: 'DebrisFlow Predictor',
      menuItems: [
        {
          label: 'Predictor',
          icon: 'symbol-landslide symbol-outlined',
          routerLink: 'predictor',
        },
        {
          label: 'Pricing Tool',
          icon: 'symbol-paid symbol-outlined',
          routerLink: 'pricing-tool',
          command: () =>
            LinkService.OpenExternalLink(this.appConfig.pricingToolLink),
        },
        {
          label: 'Simulations Dashboard',
          icon: 'symbol-inventory-2 symbol-outlined',
          routerLink: 'simulations',
        },
      ],
    },
  ];

  public footerMenuItems: MenuItem[] = [
    {
      label: 'Need help?',
      icon: 'symbol-help symbol-outlined',
      command: () => {
        LinkService.OpenExternalLink(
          'https://stantecdigitalservices.atlassian.net/servicedesk/customer/portal/29/topic/f42c35b6-0cf3-4cb6-a88e-b3715f539e89'
        );
      },
    },
  ];

  public profileMenuItems: MenuItem[] = [
    {
      label: 'Profile',
      icon: 'symbol-account-circle',
      command: () => this.navigateToProfile(),
    },
    { label: 'Sign Out', icon: 'symbol-logout', command: () => this.logout() },
  ];

  logout() {
    this.authService.logoutRedirect().pipe(take(1)).subscribe();
  }

  openHomeLink() {
    LinkService.OpenExternalLink(this.homeLink, false);
  }

  navigateToProfile() {
    LinkService.OpenExternalLink(
      `${this.appConfig.digitalAccessPortal.url}/portal/profile`
    );
  }

  ngOnInit(): void {
    this.loadingIndicator();

    if (this.store.selectSnapshot(UserState.manageLicensePageAccess)) {
      this.navItems[0].menuItems.push({
        label: 'Manage Licenses',
        icon: 'symbol-monitoring symbol-outlined',
        routerLink: ['/manage-enterprises-license'],
        routerLinkActiveOptions: { exact: true }
      });
    }

    this.store.dispatch(new UserActions.GetLicenseAccess());

    this.store
      .select(UserState.userLicenseAccess)
      .subscribe((licenseAccess) => {
        this.LicenseUser = licenseAccess;

        if (
          this.LicenseUser?.isManager &&
          !this.navItems[0].menuItems.find(
            (item) => item.label === 'Enterprise License Details'
          )
        ) {
          this.navItems[0].menuItems = [
            ...this.navItems[0].menuItems,
            {
              label: 'Enterprise License Details',
              icon: 'symbol-folder symbol-outlined',
              routerLink: 'enterprises-license-details',
            },
          ];
        }

        const licenseStatus = this.LicenseUser?.licenseStatusValue;
        if(licenseStatus === 'RenewalPending' && !this.hasShownRenewalPendingToast) {
          this.hasShownRenewalPendingToast = true;
          // this.messageService.add({
          //   severity:'warn', 
          //   summary:'Enterprise License Renewal Pending', 
          //   detail:`Your Enterprise License will expire on ${this.LicenseUser.licenseExpiryDate}. If not renewed, access will be lost. '<a href="https://stantecdigitalservices.atlassian.net/servicedesk/customer/portal/29/group/134/create/1081" target="_blank" style="color:#fff;text-decoration:underline;">Click here to renew</a>`,
          //   sticky:true,
          //   closable:true

          // });

          let formattedDate = this.appDatePipe.transformWithFormat(this.LicenseUser.licenseExpiryDate, APP_DATE_FORMATS.APP_DATE_ONLY_FORMAT);
          this.expiryNotificationService.showToast(
            `Your Enterprise License expires on ${formattedDate}. To renew, click the "?" icon in the bottom left corner, then select raise a request.`,
            'warn'
          );
        }

      });
    this.loadingIndicator();
  }

  constructor(
    private router: Router,
    private authService: MsalService,
    @Inject(APP_CONFIG) private appConfig: AppConfig,
    private store: Store,
    private readonly expiryNotificationService: ExpiryNotificationService,
    private readonly appDatePipe: AppDatePipe,
  ) {}
}
